import { Component, OnInit } from '@angular/core';
import { DialogState } from '../../models/dialog-state';
import { DialogTypeEnum } from '../../enums/dialog-type.enum';
import { ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { CaptchaService } from '../../services/captcha.service';

@Component({
  selector: 'app-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommonDialogComponent implements OnInit {
  public set currentState(newState: DialogState) {
    this.isDialogVisible = !!newState;
    if (this.isDialogVisible) {
      this.state = newState;
      this.isTextContent = typeof newState.content === 'string';
    }
  }

  public get currentState() {
    return this.state;
  }

  public get isDialogVisible(): boolean {
    return this._isDialogVisible;
  }

  public set isDialogVisible(value: boolean) {
    if (this._isDialogVisible !== value) {
      this._isDialogVisible = value;

      if (!value) {
        this.onHide();
      }
    }
  }
  public isAccepted = false;
  public isMaximizableDisplay = false;
  public isTextContent = true;
  public dialogEnum = DialogTypeEnum;
  public isCaptchaVisible: Observable<boolean> = this._captchaService.isCaptchaVisible$;
  public isCaptchaPassed: Observable<boolean> = this._captchaService.isCaptchaPassed$;
  private state: DialogState;
  private _isDialogVisible = false;

  constructor(
    private _captchaService: CaptchaService
  ) {}

  ngOnInit() {}

  public onHide() {
    if (this.state.onHide) {
      this.state.onHide(this.isAccepted);
    }
  }
  public onAccept($event) {
    if (this.state.onAccept) {
      this.state.onAccept($event);
    }
    this.isAccepted = true;
    this.isDialogVisible = false;
  }

  public onClose() {
    this.isAccepted = false;
    this.isDialogVisible = false;
  }

  public onShow($event) {
    this.isDialogVisible = true;
    if (this.state.onShow) {
      this.state.onShow($event);
    }
  }

  public onMaximize($event) {
    this.isMaximizableDisplay = $event.maximized;
  }
}
